import React, { useCallback } from 'react';
import Chip from '@mui/material/Chip';

// Memoized component for status filter chips
const StatusFilterChip = React.memo(
  ({ status, isSelected, getStatusColor, onStatusClick }) => {
    const handleClick = useCallback(() => {
      onStatusClick(status);
    }, [status, onStatusClick]);

    return (
      <Chip
        label={status.charAt(0).toUpperCase() + status.slice(1)}
        color={getStatusColor(status)}
        variant={isSelected ? 'filled' : 'outlined'}
        onClick={handleClick}
        sx={{ cursor: 'pointer' }}
      />
    );
  },
);

StatusFilterChip.displayName = 'StatusFilterChip';

export default StatusFilterChip;
